import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-menu user-select-none" }
const _hoisted_2 = { class: "operator-login" }

import {ref, computed, watch} from 'vue';
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import operatorLogout from "~/operatorApplication/ts/service/status/OperatorLogout";
import {
    OPERATOR_STATUS_INVISIBLE
} from "~/chat/ts/data/OperatorStatus";
import {__} from "~/ts/library/Translate";
import setOperatorStatus from "~/operatorApplication/ts/service/status/SetOperatorStatus";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import {
    OPERATOR_APPLICATION_MENU_ITEM_BUDDY_LIST_KEY,
    OperatorApplicationMenuItem,
    OperatorApplicationMenuSection
} from "~/operatorApplication/vue/layout/Interface";
import {OperatorApplicationRoutingStore} from "~/operatorApplication/ts/store/OperatorApplicationRoutingStore";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";

import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApplicationMainMenuItem from "~/operatorApplication/vue/layout/OperatorApplicationMainMenuItem.vue";
import StringHelper from "../../../ts/library/StringHelper";


import Draggable from "vuedraggable";

const __default__ = {
    name: "OperatorApplicationMainMenu",
    components: {
        Draggable
    }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let menu = ref<OperatorApplicationMenuSection[]>();

let menuFromStore = OperatorApplicationRoutingStore.menu;

function initMenu() {
    menu.value = [...menuFromStore.value as any];
}


initMenu();

let operatorStore = computed(() => {
    return OperatorAccountStore;
});

function setSectionId(item: OperatorApplicationMenuItem) {
    OperatorApplicationRoutingStore.setSectionId(item.sectionId);
}

function itemType(item: any): OperatorApplicationMenuItem {
    return item;
}

let selectedSectionId = OperatorApplicationRoutingStore.sectionId;

let statusList = OperatorAccountStore.statusList;

let availableForOperatorStatusList = computed(() => {
    return statusList.value.filter(item => {
        return !(item.statusId == OPERATOR_STATUS_INVISIBLE && !OperatorAccountStore.data.value.accessRights.canSwitchStatusToInvisible);
    });
});

let currentStatus = computed(() => {
    let status = statusList.value.find(status => {
        let currentStatus = OperatorAccountStore.status.value;
        return status.statusId == currentStatus.id && status.customStatusId == currentStatus.customId;
    });
    if (!status) {
        status = statusList.value.find(status => status.statusId == OperatorAccountStore.status.value.id);
    }
    if (status) {
        if (!OperatorAccountStore.data.value.isWorkingNow) {
            status = {statusId: OPERATOR_STATUS_INVISIBLE, descr: __("Выходной"), color: 'greensea'};
        }
        return status;
    }
    return null;
});


watch(menuFromStore, () => initMenu(), {deep: true});

let chatsBadge = ClientUserdataStore.mainBuddyListUnreadedCount;

watch(chatsBadge, () => OperatorApplicationPlatform.window.setBadge(chatsBadge.value));

function onStatusMenuCommand(command: "exit" | string) {
    if (command == "exit") {
        operatorLogout();
    } else {
        let json = JSON.parse(command);
        setOperatorStatus(json.statusId, json.customStatusId, false, true);
    }
}

async function onSort() {
    let section = menu.value.find(section => section.sortable);
    if (section) {
        let buddyList: OperatorApplicationApi.OperatorBuddyListConfigOpenApiModel[] = section.items.map(item => item.props[OPERATOR_APPLICATION_MENU_ITEM_BUDDY_LIST_KEY]);
        if (buddyList.length > 1) {
            let p: OperatorApplicationApi.OperatorBuddyListOrderSearchOpenApiModel = {
                idList: buddyList.map(item => item.id)
            };
            (new OperatorApiRequest({
                url: "/buddyList/orderSearch",
                p,
                silent: true
            })).send();
        }
    }
}

let login = computed(() => OperatorAccountStore.operator.value.login);



return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, {
      class: "d-block menu-item",
      trigger: "click",
      onCommand: onStatusMenuCommand
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableForOperatorStatusList), (item) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                key: `${item.statusId}_${item.customStatusId}`,
                class: "status-dropdown-item",
                command: JSON.stringify({ statusId: item.statusId, customStatusId: item.customStatusId })
              }, {
                default: _withCtx(() => [
                  _createVNode(FontAwesomeIcon, {
                    icon: "circle",
                    style: _normalizeStyle({
                            color: item.color ? `${item.color} !important` : null
                        }),
                    class: _normalizeClass(`icon text-status-${item.statusId}`),
                    bold: item === _unref(currentStatus)
                  }, null, 8, ["style", "class", "bold"]),
                  _createTextVNode(" " + _toDisplayString(_unref(StringHelper).capitalize(item.descr)), 1)
                ]),
                _: 2
              }, 1032, ["command"]))
            }), 128)),
            _createVNode(_component_el_dropdown_item, { command: "exit" }, {
              default: _withCtx(() => [
                _createVNode(FontAwesomeIcon, {
                  icon: "sign-out",
                  class: "text-red"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(StringHelper).capitalize(_unref(__)("выход"))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(CoreUiOperatorAvatar, {
            operator: {..._unref(operatorStore).operator.value, statusId: _unref(operatorStore).status.value.id},
            "status-color": _unref(currentStatus).color,
            size: "3.1em"
          }, null, 8, ["operator", "status-color"]),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(login)), 1),
          (_unref(currentStatus))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(`bg-${_unref(currentStatus).colorClassName} status-descr`),
                style: _normalizeStyle({
                        background: _unref(currentStatus).color ? `${_unref(currentStatus).color} !important` : null
                    })
              }, _toDisplayString(_unref(StringHelper).capitalize(_unref(currentStatus).descr)), 7))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (section, index) => {
      return (_openBlock(), _createBlock(_unref(Draggable), {
        key: index,
        "item-key": "sectionId",
        disabled: !section.sortable,
        modelValue: _unref(menu)[index].items,
        "onUpdate:modelValue": ($event: any) => ((_unref(menu)[index].items) = $event),
        onSort: onSort
      }, {
        item: _withCtx(({element}) => [
          (_openBlock(), _createBlock(OperatorApplicationMainMenuItem, {
            key: index,
            item: itemType(element),
            selected: itemType(element).sectionId === _unref(selectedSectionId),
            onClick: ($event: any) => (setSectionId(itemType(element)))
          }, null, 8, ["item", "selected", "onClick"]))
        ]),
        _: 2
      }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"]))
    }), 128))
  ]))
}
}

})